import React from "react";

import { StyledSVG } from "../StyledIcon";

export const AlertIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M8.14672 2.89628C8.53665 2.25821 9.46335 2.25821 9.85328 2.89628L16.3202 13.4785C16.7274 14.1449 16.2479 15 15.4669 15H2.53306C1.75213 15 1.27256 14.1449 1.67978 13.4785L8.14672 2.89628Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9.75L9 6"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12.75V12"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
